module.exports = __webpack_public_path__ + "89aaf05f64fd1fb82a67d79f38ef4f25.pdf";